<template>
  <main class="wrapper">
    <p>Согласно ГОСТ20548-87 Объемное содержание угарного газа (СО) в продуктах сгорания не должно превышать <span class="red">119 мг/м3</span> или <span class="red">102ррм</span>. Опасным считается превышение в воздухе <span class="orange"> более 50 ррм</span>.</p>
    <div id="co-image">
      <img src="../img/co2.webp" alt="защита от угарного газа">
    </div>
    <p>Для контроля наличия СО в помещении используется датчик СО, при превышении порогового значения в 50 ррм, блокируется подача газа и/или работа котла с выдачей соответствующего сигнала. При нормализации параметров блокировка автоматически снимается. Аналогично происходит блокировка при достижении 10% от взрывоопасного содержания газа СН4/ С3Н8 в воздухе.</p>
    <p>Стоимость оборудования и установки сигнализатора  с датчиками на СО и утечку природного газа СН4 - <span class="red">6500руб</span>. Датчики внесены в РОСРЕЕСТР и поставляются с поверкой метрологической лаборатории.</p>
  </main>
</template>

<script>
  export default {

  }
</script>

<style scoped>

.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

p {
  text-align: justify;
  text-indent: 50px;
  padding: 30px;
  font-size: 2em;
  margin: 10px 5%;
}

img {
  width: 80%;
  height: auto;
}

#co-image {
  text-align: center;
  max-width: 1600px;
}

@media (max-width: 900px) {
  #co-image {
    text-align: center;
    padding-left: 0;
    padding-right: 0;
    margin-left: 0;
    margin-right: 0;
  }

  img {
    width: 100%;
  }
}

@media (max-width: 800px) {
  p {
    font-size: 1.2em;
  }
}

@media (max-width: 600px) {
  p {
    font-size: 1em;
    margin: 10px;
    padding: 10px;
  }
}

</style>